import { Clock } from "lucide-react";
import { MaskedLines, Reveal, Eyebrow } from "@/components/site/Motion";
import { ContactBlock } from "@/components/site/ContactBlock";
import { CONTACT } from "@/data/site";

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <section className="mx-auto max-w-[1440px] px-5 pb-10 pt-36 sm:px-8 lg:px-12 lg:pt-44">
        <p className="mb-6 font-mono text-xs uppercase tracking-[0.3em] text-[#C8D484]">Contactos · Palmeira, Braga</p>
        <MaskedLines
          testId="contact-title"
          lines={["Fale", "connosco."]}
          className="font-display text-[20vw] font-semibold uppercase leading-[0.82] tracking-tight sm:text-[14vw] lg:text-[10vw]"
          lineClassName={(i) => (i === 1 ? "font-serif text-[#C8D484] italic normal-case font-normal tracking-normal" : "")}
        />
      </section>
      <ContactBlock title="Envie o seu pedido" />
      <section className="mx-auto grid max-w-[1440px] gap-10 px-5 pb-24 sm:px-8 lg:grid-cols-12 lg:px-12">
        <Reveal className="lg:col-span-4">
          <Eyebrow>Onde estamos</Eyebrow>
          <p className="mt-5 font-display text-4xl font-semibold uppercase leading-none">{CONTACT.address}</p>
          <p className="mt-6 flex items-start gap-3 text-white/75">
            <Clock className="mt-1 h-4 w-4 shrink-0 text-[#C8D484]" />
            <span data-testid="contact-hours">Horário: 09:00 – 18:00 — visitas por marcação.</span>
          </p>
          <a href={CONTACT.mapLink} target="_blank" rel="noreferrer" data-testid="contact-map-link" className="mt-8 inline-flex rounded-full border border-white/30 px-6 py-3 text-sm font-semibold transition-colors hover:border-[#C8D484] hover:text-[#C8D484]">
            Abrir no Google Maps
          </a>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-8">
          <div className="h-[380px] overflow-hidden border border-white/10 sm:h-[460px]">
            <iframe title="Mapa DOG'Z" data-testid="contact-map" src={CONTACT.mapEmbed} className="h-full w-full grayscale invert-[0.9] contrast-[0.9]" loading="lazy" />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
